import type { SITE_WEATHER_CONDITIONS, SiteWeather } from '@epc/contracts';

export const WEATHER_CONDITION_LABELS: Record<(typeof SITE_WEATHER_CONDITIONS)[number], string> = {
  clear: 'Ясно',
  cloudy: 'Облачно',
  rain: 'Дождь',
  snow: 'Снег',
  wind: 'Ветер',
  fog: 'Туман',
  other: 'Другое',
};

export function emptyWeather(): SiteWeather {
  return { temperatureC: null, condition: null, windMs: null, note: null };
}

export function weatherSummary(weather: SiteWeather | null | undefined): string | null {
  if (!weather) return null;
  const parts: string[] = [];
  if (weather.temperatureC !== null) parts.push(`${weather.temperatureC} °C`);
  if (weather.condition) parts.push(WEATHER_CONDITION_LABELS[weather.condition]);
  if (weather.windMs !== null) parts.push(`ветер ${weather.windMs} м/с`);
  if (weather.note?.trim()) parts.push(weather.note.trim());
  return parts.length ? parts.join(' · ') : null;
}
